import { render } from "./StatusAutomatic.vue?vue&type=template&id=62f0db00"
import script from "./StatusAutomatic.vue?vue&type=script&lang=js"
export * from "./StatusAutomatic.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__